const Constants = {
  a4b: {
    key: "a4b",
    ver: "1.0"
  },
  registry: {
    key: "device-registry",
    ver: "1.0"
  },
  pholioUserAuth: {
    key: "auth-user-pholio",
    ver: "0.1"
  },
  orionUserAuth: {
    key: "user-auth-login",
    ver: "1"
  },
  userAppTokens: {
    key: "user-app-tokens",
    ver: "1"
  },
  userInfo: {
    key: "user-info",
    ver: "1"
  },
  userProvisioning: {
    key: "user-auth-provisioning",
    ver: "1"
  },
  userAddOAuthResource: {
    key: "user-add-oauth-resource",
    ver: "1"
  },
  locations: {
    key: "device-location",
    ver: "1.0"
  },
  vault: {
    key: "vault",
    ver: "1.0"
  },
  //deviceProxyClient: {
  //  key: "device-proxy-client",
  //  ver: "1"
  //},
  localUser: {
    key: "user-local-user",
    ver: "1"
  },
  accessControl: {
    key: "user-access-control",
    ver: "1"
  },
  licensing: {
    key: "licensing",
    ver: "1.0"
  },
  deviceMessaging: {
    key: "device-messaging-client",
    ver: "1.0"
  },
  deviceProvision: {
    key: "device-tenant-provisioning",
    ver: "1.0"
  },
  tenantManager: {
    key: "tenant-manager",
    ver: "1.0"
  },
  pholioAppName: "pholio",
  enterpriseAdminRole: "EnterpriseAdmin",

  USER_PERMISSIONS: "USER_PERMISSIONS"
};

export const GlobalConstants = {
  STATUS: {
    init: "_init",
    trying: "_trying",
    done: "_done",
    error: "_error",
    partly: "_partly"
  }
};

export const URL = {
  ROOT: "/",
  LOGIN: "/", // we don't use login page anymore
  SWITCH: "/switch",
  DISPATCH: "/dispatch",
  LOGIN_FAILED: "/login/loginFailed",
  REGISTER: "/register",
  SELF_REG: "/createAccount",
  SELF_REG_2: "/createAccount_2",
  VERIFY_DOMAIN: "/verifyDomains",
  NO_ROLE: "/no-role",
  TENANT_PORTAL: {
    ROOT: "/tenant-portal",
    CLOUD_DEVICES: "/tenant-portal/cloud-devices",
    USER: "/tenant-portal/user-management",
    ACTIVITY: "/tenant-portal/activity-logs",
    AUTH_PRO: "/tenant-portal/auth-providers",
    DOC_SERV: "/tenant-portal/services",
    LICENSE: "/tenant-portal/license",
    ACCOUNT_CODE: "/tenant-portal/account-code",
    DOMAIN_MANAGEMENT: "/tenant-portal/domain-management",
    API_KEYS: "/tenant-portal/api-keys",
    PROFILE: "/tenant-portal/profile-update",
    TENANT_OF_TENANT: "/tenant-portal/sub-organization"
  },
  A4B: {
    ROOT: "/a4b",
    SERVICE_CONFIG: "/a4b/service-config",
    AMAZON_ACCOUNT: "/a4b/amazon-account"
  },
  CLOUDSVC: {
    OTD: "https://otd.plcm.vc",
    REALCONNECT: "https://webapp.plcm.vc"
  }
};

export const COLORS = {
  BASE_BLUE: "#1177B8",
  LIGHT_BLUE: "#09B6CF",
  BLUE_GREEN: "#08C5A9",
  critical: "#ff1d00",
  major: "#ff5d00",
  minor: "#ffdf16",
  normal: "#1177B8",
  failed: "#ff1d00"
};

export const ROLES = {
  DEVICE_ADMIN: { label: "Device Admin", value: "DeviceAdmin" },
  DEVICE_OPERATOR: { label: "Device Operator", value: "DeviceOperator" },
  ENTERPRISE_ADMIN: { label: "Enterprise Admin", value: "EnterpriseAdmin" },
  LICENSE_ADMIN: { label: "License Admin", value: "LicenseAdmin" },
  USER_ADMIN: { label: "User Admin", value: "UserAdmin" },
  PDMSSP_ADMIN: { label: "PDMS-SP Admin", value: "PDMSSPAdmin" },
  PDMSSP_USER: { label: "PDMS-SP User", value: "PDMSSPUser" },
  OTD_ADMIN: { label: "OTD Admin", value: "OTDAdministrator" }
};

export const SIDEBAR_WIDTH = {
  WIDTH: 256,
  THIN: 63
};

export const BUILD_IN_TYPES = {
  O365AppAuth: "Microsoft Office 365"
};

export default Constants;



// WEBPACK FOOTER //
// ./src/common/Constants.js